import {
    STATISTICS_QUIZ_SUCCESS,
    DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE_SUCCESS
} from './constants';

const initialStstisticsQuizzesState = {};
/**
 *
 * @param state
 * @param action
 * @returns {{}|{fileLink: {url: string}}}
 */
const ststisticsQuizzesReducer = ( state = initialStstisticsQuizzesState, action ) => {

    switch ( action.type ) {
        case STATISTICS_QUIZ_SUCCESS: {

            return { ...action.ststistics };
        }
        case DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE_SUCCESS: {
            return { fileLink: action.fileLink, ...state };
        }
        default:
            return state;
    }
};

export { ststisticsQuizzesReducer as quizstst };
